import * as libCrypto from '@ownerone/lib-crypto';
import forge from 'node-forge';

import { DecryptedFile, EncryptedFile, SymmetricKey } from './types';

const ENCRYPTED_FILE_DELIMITER = '<!_!>ENCRYPTED_FILE_DELIMITER<!_!>';

const chunkArray = (input: Uint8Array, chunkSize: number): Uint8Array[] => {
  let index = 0;
  const arrayLength = input.length;
  const chunks = [];

  while (index < arrayLength) {
    chunks.push(input.slice(index, index + chunkSize));
    index += chunkSize;
  }

  return chunks;
};

const encryptFile = async (file: File, key: SymmetricKey): Promise<EncryptedFile> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const plaintext = new Uint8Array(reader.result as ArrayBuffer);
      const chunks = chunkArray(plaintext, 1000);
      const encodedData = chunks.map((chunk) => forge.util.binary.raw.encode(chunk));
      const dataWithMimeType = `${file.type}${ENCRYPTED_FILE_DELIMITER}${encodedData.join('')}`;

      resolve(libCrypto.aes.encrypt(dataWithMimeType, key));
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
};

const decryptFile = async (
  file: EncryptedFile,
  key: SymmetricKey,
  fileName?: string,
): Promise<DecryptedFile> => {
  const dataWithMimeType = libCrypto.aes.decrypt(file, key);
  const [mimeType, data] = dataWithMimeType.split(ENCRYPTED_FILE_DELIMITER);
  const arrayBuffer = new Uint8Array(forge.util.binary.raw.decode(data)).buffer;
  return new File([arrayBuffer], fileName || 'decrypted', { type: mimeType });
};

export { encryptFile, decryptFile };
